import { Component, Input, OnInit } from '@angular/core';
import { IssueOverviewModel, SubTitleWrapper } from 'src/app/classes';
import * as moment from 'moment';

@Component({
  selector: 'app-change-preview',
  templateUrl: './change-preview.component.html',
  styleUrls: ['./change-preview.component.css']
})
export class ChangePreviewComponent implements OnInit {

  _issue: IssueOverviewModel;
  @Input() set issue(issue: IssueOverviewModel){
    this._issue = issue;
    if(issue){
      if(issue.state) this.subTitles.push({ value: issue.state, type: "Status" });
      if(issue.changetype) this.subTitles.push({ value: issue.changetype, type: "RFC Art" });
      if(issue.issueescalation) this.subTitles.push({ value: moment(issue.issueescalation).format("DD.MM.YYYY HH") + " Uhr", type: "Wunschdatum" });
    }
  }
  get issue(): IssueOverviewModel {
    return this._issue;
  }

  subTitles: SubTitleWrapper[] = [];

  constructor() {

  }

  ngOnInit(): void {
  }

}
